import { connect } from 'react-redux';
import ScribeScrollWithTranscript from './ScribeScrollWithTranscript';
const mapStateToProps = (state) => {
    const { transcriptsCurrent, ui: { keyboardInputShown }, transcripts, } = state.scribeConversation;
    const { sidebar, lightView, intercomOpen } = state.scribeSession;
    const { fullScreen, bottomMenu, electronCaptionMode } = state.scribeTranscriptUI;
    return {
        bottomMenu,
        electronCaptionMode,
        fullScreen,
        intercomOpen,
        lightView,
        keyboardInputShown,
        sidebar,
        transcriptsCurrent,
        transcript: transcripts[transcriptsCurrent[transcriptsCurrent.length - 1]],
        transcripts,
    };
};
const mapDispatchToProps = {
    setIntercomOpen: (open) => ({
        type: 'SET_INTERCOM_OPEN',
        open,
    }),
};
export default connect(mapStateToProps, mapDispatchToProps)(ScribeScrollWithTranscript);
